import type { IconData } from '@stacksjs/iconify-core'

export const opera: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11.996 2c-5.462 0-9.278 3.958-9.278 9.899C2.718 17.189 6.43 22 12.004 22c5.567 0 9.278-4.819 9.278-10.101c0-5.94-3.824-9.899-9.286-9.899m0 18.384c-3.397 0-3.77-5.013-3.77-8.71V11.6c0-3.996.598-8.23 3.748-8.23s3.786 4.361 3.786 8.357c0 3.696-.367 8.657-3.764 8.657\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default opera
